import { ChalkCard } from "../../components/chalk/primitives";

const money = (c) => `$${((c || 0) / 100).toFixed(2)}`;

export function RefundReasonsCard({ data }) {
  if (!data) return null;
  const max = Math.max(1, ...data.reasons.map((r) => r.count));
  return (
    <ChalkCard data-testid="refund-reasons-card">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 10 }}>
        <div style={{ fontSize: 14, color: "var(--chalk-board)", fontWeight: 500 }}>Refund reasons · last {data.days} days</div>
        <div data-testid="refund-reasons-total" style={{ fontSize: 12, color: "var(--chalk-muted)" }}>
          {data.total} refund{data.total === 1 ? "" : "s"} · {money(data.total_cents)}
        </div>
      </div>
      {data.total === 0 ? (
        <div style={{ fontSize: 12, color: "var(--chalk-muted)", marginTop: 8 }}>No refunds yet.</div>
      ) : (
        <div style={{ marginTop: 10, display: "grid", gap: 6 }}>
          {data.reasons.map((r) => (
            <div key={r.reason} data-testid={`refund-reason-row-${r.reason}`} style={{ display: "grid", gridTemplateColumns: "120px 1fr 28px", gap: 8, alignItems: "center", fontSize: 12 }}>
              <span style={{ color: "var(--chalk-board)" }}>{r.label}</span>
              <span style={{ height: 8, borderRadius: 999, background: "var(--chalk-border)", overflow: "hidden" }}>
                <span style={{ display: "block", height: "100%", width: `${(r.count / max) * 100}%`, background: "var(--chalk-board)" }} />
              </span>
              <span style={{ textAlign: "right", color: "var(--chalk-muted)" }}>{r.count}</span>
            </div>
          ))}
        </div>
      )}
      {data.recent_notes.length > 0 && (
        <div style={{ marginTop: 12, borderTop: "0.5px solid var(--chalk-border)", paddingTop: 10 }}>
          <div style={{ fontSize: 11, letterSpacing: "0.1em", textTransform: "uppercase", color: "var(--chalk-muted)" }}>Recent notes</div>
          {data.recent_notes.map((n) => (
            <div key={n.at} style={{ fontSize: 12, color: "var(--chalk-board)", marginTop: 6 }}>
              <b>{n.reason}:</b> {n.note}
            </div>
          ))}
        </div>
      )}
    </ChalkCard>
  );
}
